var _rect, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationPhotoLike(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#11AB96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.73 5.875V14.345C14.73 14.5576 14.5576 14.73 14.345 14.73H5.875C5.875 15.1553 6.21974 15.5 6.645 15.5H14.345C14.9829 15.5 15.5 14.9829 15.5 14.345V6.645C15.5 6.21974 15.1553 5.875 14.73 5.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.125 5.61058V13.0144C14.125 13.6278 13.6278 14.125 13.0144 14.125H5.61058C4.99722 14.125 4.5 13.6278 4.5 13.0144V5.61058C4.5 4.99722 4.99722 4.5 5.61058 4.5H13.0144C13.6278 4.5 14.125 4.99722 14.125 5.61058ZM9.68275 10.6415L11.2709 9.04967C11.3409 8.98008 11.4358 8.94132 11.5345 8.94202C11.6332 8.94271 11.7275 8.9828 11.7965 9.05338L13.3847 10.6415V5.61059C13.3847 5.40614 13.2189 5.2404 13.0145 5.2404H5.61064C5.40618 5.2404 5.24044 5.40614 5.24044 5.61059V11.3819L7.57265 9.05338C7.71704 8.90984 7.95024 8.90984 8.09463 9.05338L9.68275 10.6415Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62474 6.90625C8.62474 6.33671 9.08645 5.875 9.65599 5.875C9.92949 5.875 10.1918 5.98365 10.3852 6.17705C10.5786 6.37044 10.6872 6.63275 10.6872 6.90625C10.6872 7.47579 10.2255 7.9375 9.65599 7.9375C9.08645 7.9375 8.62474 7.47579 8.62474 6.90625ZM9.31223 6.90623C9.31223 7.09608 9.46613 7.24998 9.65598 7.24998C9.84583 7.24998 9.99973 7.09608 9.99973 6.90623C9.99973 6.71639 9.84583 6.56248 9.65598 6.56248C9.46613 6.56248 9.31223 6.71639 9.31223 6.90623Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_897_7073",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 3,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62474 6.90625C8.62474 6.33671 9.08645 5.875 9.65599 5.875C9.92949 5.875 10.1918 5.98365 10.3852 6.17705C10.5786 6.37044 10.6872 6.63275 10.6872 6.90625C10.6872 7.47579 10.2255 7.9375 9.65599 7.9375C9.08645 7.9375 8.62474 7.47579 8.62474 6.90625ZM9.31223 6.90623C9.31223 7.09608 9.46613 7.24998 9.65598 7.24998C9.84583 7.24998 9.99973 7.09608 9.99973 6.90623C9.99973 6.71639 9.84583 6.56248 9.65598 6.56248C9.46613 6.56248 9.31223 6.71639 9.31223 6.90623Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_897_7073)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationPhotoLike);
export default __webpack_public_path__ + "static/media/icNotificationPhotoLike.41a1947a2b5eab837a710d64bd04446d.svg";
export { ForwardRef as ReactComponent };